import { Box, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import React from 'react'
import BrandImage from './BrandImage'

interface ReadyInfoProps {
  imageBaseName: string
  title: string
  text: string
}

const ReadyInfo = ({
  imageBaseName,
  title,
  text,
}: ReadyInfoProps): JSX.Element => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        width: '100%',
      }}
    >
      <Stack
        sx={{
          py: 2,
          px: 3,
          mx: 'auto',
          my: 3,
          maxWidth: 'lg',
          alignItems: 'center',
          textAlign: 'center',
          '& > img': {
            mb: 2,
          },
          '& > p': {
            mt: 1,
          },
        }}
        gap={1}
      >
        <BrandImage imageBaseName={imageBaseName} altText={title} />
        <Typography
          variant="h3"
          component="h1"
          aria-live="polite"
          aria-atomic="true"
        >
          {title}
        </Typography>
        <Typography variant="body2" component="p">
          {text}
        </Typography>
      </Stack>
    </Box>
  )
}

export default ReadyInfo
